import { useDispatch } from 'react-redux';
import { startRegistration } from '@simplewebauthn/browser';
import { dialogErrorsUtil } from '../../../../../utils/ErrorHandling/dialogErrorUtil';
import { passkeysSnackUtil } from '../passkeysSnack.util';
import { isRefusedByPartialPasskeySupport } from '../../../../../utils/passkeySupportUtils';
import { globalFeedbackUtil } from '../../../../../utils/FeedbackUtils/globalUtils';
import { fetchUserPasskeys } from '../../../../../globalStore/userPasskeys.thunks';
import {
  generatePasskeyRegistrationOptionsAPI,
  registerPasskeyAPI,
} from '../../../../../API/services';

export const useRegisterPasskey = () => {
  const dispatch = useDispatch();

  const handleRegisterPasskey = async ({
    passkeyName,
    onSuccess = () => {},
  }) => {
    globalFeedbackUtil.setBackdropIndeterminate({ clickable: false });

    let optionsJSON;
    let challengeId;
    try {
      const response = await generatePasskeyRegistrationOptionsAPI({}, {}, {});
      if (response.status !== 200) {
        dialogErrorsUtil.errorOnServer();
        globalFeedbackUtil.closeBackdrop();
        return;
      }
      optionsJSON = response.data.data.options;
      challengeId = response.data.data.challengeId;
    } catch (error) {
      dialogErrorsUtil.errorOnServer();
      globalFeedbackUtil.closeBackdrop();
      return;
    }

    let attResp;
    try {
      attResp = await startRegistration({ optionsJSON });
    } catch (error) {
      globalFeedbackUtil.closeBackdrop();
      if (error.name === 'InvalidStateError') {
        passkeysSnackUtil.passkeyAlreadyRegistered();
        return;
      }
      if (await isRefusedByPartialPasskeySupport(error)) {
        passkeysSnackUtil.passkeyPartialSupportFailed();
        return;
      }
      passkeysSnackUtil.passkeyRegistrationFailed();
      return;
    }

    try {
      const verificationResponse = await registerPasskeyAPI(
        { attResp, deviceName: passkeyName, challengeId },
        {},
        {},
      );

      if (verificationResponse.status !== 200) {
        passkeysSnackUtil.passkeyVerificationFailed();
        return;
      }

      const { verified } = verificationResponse.data.data;
      if (!verified) {
        passkeysSnackUtil.passkeyVerificationFailed();
        return;
      }

      await dispatch(fetchUserPasskeys()).unwrap();
      onSuccess();
    } catch (error) {
      dialogErrorsUtil.errorOnServer();
    } finally {
      globalFeedbackUtil.closeBackdrop();
    }
  };

  return { handleRegisterPasskey };
};
